<template>
    <el-drawer
        :title="!id ? '新增直播事件' : '编辑直播事件'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-alert
                title="发布预告后将自动通知粉丝"
                type="warning"
                :closable="false">
            </el-alert>
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                v-loading="dataLoading"
            >
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" >
                        <el-form-item prop="title" label="标题:">
                            <el-input
                                v-model="formData.title"
                                placeholder="请输入标题"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" >
                        <el-form-item prop="liveUserId" label="直播用户ID:">
                            <el-input
                                v-model="formData.liveUserId"
                                placeholder="请输入直播用户ID"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" >
                        <el-form-item prop="pushUserId" label="推流用户ID:">
                            <el-input
                                v-model="formData.pushUserId"
                                placeholder="请输入推流用户ID"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" >
                        <el-form-item prop="serialNum" label="序号:">
                            <el-input
                                v-model="formData.serialNum"
                                placeholder="请输入序号"
                                type="number"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24">
                        <el-form-item prop="datetimerange" label="直播时间:">
                            <el-date-picker
                                v-model="formData.datetimerange"
                                type="datetimerange"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                unlink-panels
                                size="medium">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24">
                        <el-form-item prop="playbackUrl">
                            <span slot="label">回放链接: <small>直播结束后用户可浏览相关视频</small></span>
                            <el-input
                                v-model="formData.playbackUrl"
                                placeholder="请输入回放链接"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>    
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    title: "",
    liveUserId: "",
    pushUserId: "",
    serialNum: 0,
    playbackUrl:'',
    beginTime:'',
    endTime:'',
    datetimerange:[]
}
export default {
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                title: [{ required: true, message: "请输入标题" }],
                liveUserId: [{ required: true, message: "请输入直播用户ID" }],
                pushUserId: [{ required: true, message: "请输入推流用户ID" }],
                datetimerange:[{ required: true, message: "请选择直播时间段" }],
                serialNum: [{ required: true, message: "请输入序号" }],
            },
            id:''
        };
    },
    methods: {
        close() {
            this.formData = {...defaultFormData};
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(id) {
            this.id = id;
            if(this.id){
                this.getDataDetail();
            }
            this.drawerShow = true;
        },
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/live/event/detail",
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...result,
                            datetimerange:[result.beginTime,result.endTime]
                        };
                    } else {
                        self.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _url = this.id
                        ? "/live/event/update"
                        : "/live/event/create";
                    this.btnLoading = true;

                    this.formData.beginTime = this.formData.datetimerange[0]
                    this.formData.endTime = this.formData.datetimerange[1]

                    this.$request({
                        url: _url,
                        data: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.el-alert{
    margin-bottom: 20px;
}
</style>